/**
 * /audit/ — the external-auditor's granted-trust index (route shell).
 *
 * Screen impl in `./index-screen.tsx`, lazy-loaded so the auditor surface stays
 * out of the trustee/admin initial payload (a normal user never lands here).
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/audit/')({
  component: lazyRouteComponent(() => import('./index-screen'), 'AuditIndex'),
});
